import { render, staticRenderFns } from "./SettingsCheckbox.vue?vue&type=template&id=eff44c78&"
import script from "./SettingsCheckbox.vue?vue&type=script&lang=js&"
export * from "./SettingsCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eff44c78')) {
      api.createRecord('eff44c78', component.options)
    } else {
      api.reload('eff44c78', component.options)
    }
    module.hot.accept("./SettingsCheckbox.vue?vue&type=template&id=eff44c78&", function () {
      api.rerender('eff44c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsCheckbox.vue"
export default component.exports